<template>
  <div
    class="suggestion-list-component input-field"
    :class="[state, loading ? 'loading' : '']"
  >
    <input-field
      :disable="disable"
      :name="text"
      :icon-type="iconType"
      input-type="text"
      :value="inputVal"
      @stopTyping="updateInputVal"
      @key="keyEvent"
      @input="onInputUpdate"
      @blur="onBlur"
      @focus="onFocus"
      :select="true"
    />
    <ul class="suggestion-list">
      <transition-group name="list-transition">
        <li
          v-for="(item, index) in suggestionList"
          v-bind:key="item"
          class="suggestion-list__item"
          :class="{ selected: index == selectedItem }"
          @click="clickItem(index)"
        >
          {{ item }}
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script>
import InputField from "./input-field.vue";

export default {
  props: {
    text: "",
    value: "",
    iconType: { type: String, default: "" },
    dataList: {
      type: Array,
      default() {
        return [];
      },
    },
    listFilter: { type: Boolean, default: true },
    filterOnObject: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    setOnSelect: {type: Boolean, default: true}
  },
  data: function () {
    return {
      state: "",
      suggestionList: [],
      selectedItem: 0,
      clicked: false,
      inputVal: "",
      inFocus: false,
    };
  },
  mounted() {
    this.inputVal = this.value;
  },
  watch: {
    dataList() {
      this.filterList();
    },
    value() {
      this.inputVal = this.value;
    },
  },
  components: {
    "input-field": InputField,
  },
  methods: {
    onFocus() {
      this.inFocus = true;
    },
    onBlur() {
      this.inFocus = false;

      setTimeout(() => {
        this.state = "";
      }, 150);
    },
    onInputUpdate(val) {
      if(this.setOnSelect) {
        this.inputVal = val;
      }
      this.$emit("input", val);
    },
    updateInputVal(value) {
      this.$emit("updateval", value);
    },
    filterList() {
      let filteredList = [];
      let val = this.inputVal;

      if (this.listFilter) {
        let regex = new RegExp(val.trim(), "gi");

        filteredList = this.objectFilter().filter((item) => {
          let match = item.match(regex);
          if (match) {
            return item.match(regex).length > 0;
          }
        });
      } else {
        filteredList = this.objectFilter();
      }

      this.selectedItem = 0;
      this.state = filteredList.length > 0 && val.length > 0 && this.inFocus ? "open" : "";
      this.suggestionList = filteredList;
    },
    moveDown(event) {
      event.preventDefault();
      if (
        this.suggestionList.length - 1 > this.selectedItem &&
        this.state == "open"
      ) {
        this.selectedItem += 1;
      }
    },
    moveUp: function (event) {
      event.preventDefault();
      if (this.selectedItem > 0 && this.state == "open") {
        this.selectedItem -= 1;
      }
    },
    disableUpDown(event) {
      if (event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 13) {
        event.preventDefault();
      }
    },
    clickItem(index) {
      this.selectItem(index);
    },
    selectItem(index) {
      this.state = "";
      this.selectedItem = index;

      if(this.setOnSelect) {
        this.inputVal = this.suggestionList[index];
      } 
      
      this.clicked = true;
      if (typeof this.dataList[index] !== "undefined") {
        this.$emit("selectitem", { value: this.dataList[index], id: index });
      }
    },
    keyEvent(event) {
      switch (event.keyCode) {
        case 38: //Up arrow
          this.moveUp(event);
          break;
        case 40: //Down arrow
          this.moveDown(event);
          break;
        case 13: //Enter
          if (this.state.length > 0) {
            this.selectItem(this.selectedItem);
          } else {
            this.$emit("enter");
          }
          break;
      }
    },
    objectFilter: function () {
      let key = this.filterOnObject;
      if (key.length > 0) {
        return this.dataList.map(function (a) {
          return a[key];
        });
      } else {
        return this.dataList;
      }
    },
  },
};
</script>